var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBaby = function SvgBaby(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M7.375 3.612a2.6 2.6 0 0 1 .769-1.847A2.63 2.63 0 0 1 10.001 1a2.64 2.64 0 0 1 1.856.765 2.6 2.6 0 0 1 .77 1.847 2.6 2.6 0 0 1-.77 1.847 2.63 2.63 0 0 1-1.856.765 2.64 2.64 0 0 1-1.857-.765 2.6 2.6 0 0 1-.769-1.847M3.28 5.662a1.463 1.463 0 0 1 2.038-.32l1.32.955a5.74 5.74 0 0 0 6.725 0l1.32-.958a1.466 1.466 0 0 1 2.038.32 1.45 1.45 0 0 1-.32 2.027l-1.32.958q-.746.538-1.58.907v1.317H6.5V9.551a8.5 8.5 0 0 1-1.58-.907L3.6 7.686a1.446 1.446 0 0 1-.32-2.028zm3.274 6.705 2.21 1.922-.948 1.35.886.882a1.45 1.45 0 0 1 0 2.053 1.463 1.463 0 0 1-2.064 0l-1.75-1.741a1.45 1.45 0 0 1-.168-1.861l1.83-2.605zm4.686 1.922 2.21-1.922 1.83 2.605c.406.576.336 1.36-.163 1.857l-1.75 1.741a1.467 1.467 0 0 1-2.065 0 1.445 1.445 0 0 1 0-2.053l.886-.881-.948-1.35z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBaby);
export default ForwardRef;